import React from 'react'
import './style.styl'
import {
  PLACEHOLDER_PRIMARY_COLOR
} from 'components/conversation/ContactSideBar'

const CompanyInfoField = ({ primary, secondary }) => {
  return (
    <div className="company-data-content">
      <div className="company-data-secondary">{secondary}</div>
      <span className="company-data-primary">
      {
        !!primary ?
        primary :
        <svg width="120" height="12">
          <rect width="120" height="12" rx="5" style={{fill:PLACEHOLDER_PRIMARY_COLOR}}/>
        </svg>
      }
      </span>
    </div>
  )
}


export default CompanyInfoField



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/CompanyInfoField/index.js